<a class="button" [href]="url">
  <span>{{ label | replaceWhitespaceWithUnderscore }}</span>
  <div class="icon arrow-left">→</div>
</a>

